/* eslint-disable react/forbid-prop-types */
import React from "react"
import propTypes from "prop-types"
import { graphql } from "gatsby"
import styled from "styled-components"

import SEO from "../components/Seo"
import MasonryComponent from "../components/MasonryComponent"

const Wrapper = styled.div`
  max-width: 1300px;
  margin: 0 auto;
`

const InstallationsPage = ({ data }) => {
  const posts = data.allMarkdownRemark.edges

  return (
    <Wrapper>
      <SEO title="installations" />
      {posts && (
        <div>
          <MasonryComponent posts={posts} type="gallery" />
        </div>
      )}
    </Wrapper>
  )
}

InstallationsPage.propTypes = {
  data: propTypes.object.isRequired,
}

export const query = graphql`
  query {
    allMarkdownRemark(
      filter: { frontmatter: { templateKey: { eq: "installations" } } }
      sort: { fields: frontmatter___publish, order: DESC }
    ) {
      edges {
        node {
          id
          frontmatter {
            subtitle
            thumbnail
            title
            description
          }
        }
      }
    }
  }
`

export default InstallationsPage
